import { render, staticRenderFns } from "./MiniRegister.vue?vue&type=template&id=67bc967e&"
import script from "./MiniRegister.vue?vue&type=script&lang=js&"
export * from "./MiniRegister.vue?vue&type=script&lang=js&"
import style0 from "./MiniRegister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports